/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import "primeicons/primeicons.css";
import { BASE_URL } from "../../utils/config";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import TelegramWidget from "../../components/widget/telegramWidget";
import '../../style/userlist_A.css';
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import SessionLogout from "../../components/animation/sessionLogout";



const Userlist = () => {
  const navigate = useNavigate();
  // const [searchText, setSearchText] = useState('');
  const [sessionExpired, setSessionExpired] = useState(false)
  const [totalcount, setTotalcount] = useState({});
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [AgeWisechartData, setAgeWisechartData] = useState({});
  const [AgeWisechartOptions, setAgeWisechartOptions] = useState({});


  const [TopStateData, setTopStateData] = useState([]);
  const [TopCitiesData, setTopCitiesData] = useState([]);




  const [TopStatechartData, setTopStatechartData] = useState({});
  const [TopStatechartOptions, setTopStatechartOptions] = useState({});
 
  const [TotalUserData, setTotalUserData] = useState({});
  const [TotalUser, setTotalUser] = useState({});
  const [TotalUserDataOption, setTotalUserDataOption] = useState({});
  const [ActiveInactiveUserData, setActiveInactiveUserData] = useState({});
  const [ActiveSubscriptions, setActiveSubscriptions] = useState({});
  const [activeInactiveUserDataOption, setActiveInactiveUserDataOption] = useState({});
  const [BlockedUsersData, setBlockedUsersData] = useState({});
  const [GenderUsersData, setGenderUsersData] = useState({});
  const [GenderUsersDataOption, setGenderUsersDataOption] = useState({});
  const [PaidUsersData, setPaidUsersData] = useState({});
  const [PaidUsersDataOption, setPaidUsersDataOption] = useState({});
  const [CityUsersData, setCityUsersData] = useState({});
  const [CityUsersDataOption, setCityUsersDataOption] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [loginuser, setLoginuser] = useState({});
  const [userLists, setUserLists] = useState([]);
  const [messageDialog, setMessageDialog] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isFailed, setIsFailed] = useState(false)
  const [ApiError, setApiError] = useState(false)

  const currentYear = new Date().getFullYear();
  const [TotalUserYears, setTotalUserYears] = useState([]);

  const [loading, setLoading] = useState(true);
  const [TotalUserChoosenYears, setTotalUserChoosenYears] = useState(currentYear);

//   useEffect(() => {
//     FetchUserYears();                      // Total Years available in database
//     fetchtotalCount();                     // Total Count
//     fetchuserdata(TotalUserChoosenYears);  // Total Users
//     fetchTopStates();                      // Top 10 States
//     fetchTopCity();                        // Top 10 Cities
//     //fetchTotalCorrdinator();
//     // //total Coordinator

//   }, [currentYear]);

useEffect(() => {
  const loadDashboard = async () => {
    try {
      await Promise.all([
        FetchUserYears(),
        fetchtotalCount(),
        fetchuserdata(TotalUserChoosenYears),
        fetchTopStates(),
        fetchTopCity(),
      ]);
    } finally {
      setLoading(false);
    }
  };

  loadDashboard();
}, []);



  const FetchUserYears = async() => {
    console.log("Fetching user list");
    let loginuser = JSON.parse(localStorage.getItem("userdetails"));
    const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/getuseryears`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }).then((res) => res.json())
    .then((res) => {
      console.log("User year", res.years);
    if (res?.years) {
        setTotalUserYears(res.years);
    }

      else{
        if (res.status === 400) {
          setTotalUserYears([]);
        }
      }
      
    })
  }

  const fetchuserdata = async (Year) => {
    console.log("Fetching user list");
    let loginuser = JSON.parse(localStorage.getItem("userdetails"));
    const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/getTotalUserDashboardData/${Year}/null`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
            if (res?.usersData) {
                setUserLists(res.usersData);
                setCustomers(res.usersData);
          console.log("UserData ", res.usersData);

          // setfilteredUserLists(res.usersData);
          console.log(res.usersData);

          let loginuser = JSON.parse(localStorage.getItem("userdetails"));
        //   setLoginuser(loginuser);
        //   setLoading(false);
        } else {

          if (res.status === 400) {
            setUserLists([]);
            // setfilteredUserLists({});
          } else if (res.status === 403) {
            setSessionExpired(true)
            setTimeout(() => {
              setSessionExpired(false)
              navigate('/login')
            }, 5000)
          }
          else if (res.status === 401) {
            setSessionExpired(true)
            setTimeout(() => {
              setSessionExpired(false)
              navigate('/login')
            }, 5000)
          } else {


            setApiError(true);
            setMessageDialog(true);
            setTimeout(() => {
              setMessageDialog(false);
              setApiError(false);

            }, 1700);
          }
        }

      }).catch((error) => {
        setApiError(true);
        setMessageDialog(true);
        setTimeout(() => {
          setMessageDialog(false);
          setApiError(false);

        }, 1700);

      })
  };

  const fetchtotalCount = async () => {

  const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/getUserDashboardData/Count`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res?.usersData) {
          setTotalcount(res.usersData);
          setProducts(res.usersData);
        //   setLoginuser(loginuser);
        //   setLoading(false);
        } else if (res.status === 403) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (res.status === 401) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        } else {
          setApiError(true);
          setMessageDialog(true);
          setTimeout(() => {
            setMessageDialog(false);
            setApiError(false);

          }, 1700);
        }

      }).catch((error) => {
        setApiError(true);
        setMessageDialog(true);
        setTimeout(() => {
          setMessageDialog(false);
          setApiError(false);

        }, 1700);

      })
  };


  const fetchTopStates = async () => {
    const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/getTop10UserDashboardData/ALL`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res?.usersData) {
          setTopStateData(res.usersData);

        } else if (res.status === 403) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (res.status === 401) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }

      })
  }

  const fetchTopCity = async () => {
    const token = localStorage.getItem("AUTH_TOKEN");
    const response = await fetch(`${BASE_URL}/getTop10UserDashboardData/ALLCity`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res?.usersData) {
          setTopCitiesData(res.usersData);

        }
        else if (res.status === 403) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (res.status === 401) {
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }

      })
  }

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);

    const TotalUser = {
      labels: [`Total User ${totalcount.TotalUsers}`],
      datasets: [
        {
          data: [`${totalcount.TotalUsers}`],
          backgroundColor: [
            '#8ec9db'
          ],
          hoverBackgroundColor: [
            '#5c74f0'
          ]
        }
      ]
    };


    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: 'bottom' // Positions legend at the bottom
        },
      },

    };



    const ActiveSubscriberUser = {
      labels: [`Active Subscriber ${totalcount.ActiveSubscriptions}`],
      datasets: [
        {
          data: [`${totalcount.ActiveSubscriptions}`],
          backgroundColor: [
            '#36A2EB'
          ],
          hoverBackgroundColor: [
            '#36A2EB'
          ]
        }
      ]
    };

    // const InactiveUsers = {
    //   labels: [`Inactive User ${totalcount.LogoutUsers}`],
    //   datasets: [
    //     {
    //       data: [`${totalcount.LogoutUsers}`],
    //       backgroundColor: [
    //         '#e59dd4'
    //       ],
    //       hoverBackgroundColor: [
    //         '#c450a9'
    //       ]
    //     }
    //   ]
    // };


   


    const BlockedUsers = {
      labels: [`Blocked Users ${totalcount.BlockedUsers}`],
      datasets: [
        {
          data: [`${totalcount.BlockedUsers}`],
          backgroundColor: [
            '#6cdc7b'
          ],
          hoverBackgroundColor: [
            '#50c460'
          ]
        }
      ]
    };

    const PaidUsers = {
      labels: ['Paid Users', 'Free Users'],
      datasets: [
        {
          data: [`${totalcount.PaidUsers}`, `${totalcount.FreeUsers}`],
          backgroundColor: [
            '#36A2EB'
          ],
          hoverBackgroundColor: [
            '#36A2EB'
          ]
        }
      ]
    };



    setTotalUser(TotalUser)
    handleActiveInactiveUser()
    setActiveSubscriptions(ActiveSubscriberUser);
    // setInactiveUsersData(InactiveUsers);
    setBlockedUsersData(BlockedUsers);
    setChartOptions(options);

    AgeWiseDataShow();
    HandleTopStates();
    HandleTopCity();
    HandleGender();
    HandleUserMonthWise();
    handlePaidUnpaidUser();

  }, [totalcount, userLists]);




  function AgeWiseDataShow() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const data = {
      labels: ['Below 18', '18-24', '25-30', '31-40', '41-50', '51-70', 'Above 70'],
      datasets: [
        {
          label: 'Age Wise User Data',
          backgroundColor: ['#316bfe',
            '#ff8100',
            '#02b7f9',
            '#ff9028',
            '#fd4a22',
            '#9f76ff'],
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: [`${totalcount.Below18}`, `${totalcount.Age18_24}`, `${totalcount.Age25_30}`, `${totalcount.Age31_40}`, `${totalcount.Age41_50}`, `${totalcount.Age51_70}`, `${totalcount.Above70}`,]
        }
      ]
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            fontColor: textColor
          }
        },



        customClickPlugin: {
          id: 'customClickPlugin',
          afterEvent: (chart, args) => {
            const event = args.event;

            // Check if it's a click event
            if (event.type === 'click') {
              const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

              if (elements.length) {
                const { index } = elements[0];

                let labelName = data.labels[index];
                let Heading = data.labels[index];
                if (Heading === 'Below 18') {
                  labelName = 'Below18'
                }
                if (Heading === '18-24') {
                  labelName = 'Age18_24'
                }
                if (Heading === '25-30') {
                  labelName = 'Age25_30'
                }
                if (Heading === '31-40') {
                  labelName = 'Age31_40'
                }
                if (Heading === '41-50') {
                  labelName = 'Age41_50'
                }
                if (Heading === '51-70') {
                  labelName = 'Age51_70'
                }
                if (Heading === 'Above 70') {
                  labelName = 'Above70'
                }
                handleUserDataNavigate(`getUserDashboardData/${labelName}`, `Total Users Between Age Group of ${Heading}`)
              }
            }
          }
        }





      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500
            }
          },
          grid: {
            display: false,
            drawBorder: false
          }
        },
        y: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },


      },



    };


    setAgeWisechartData(data);
    setAgeWisechartOptions(options);
  }



  function HandleTopStates() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const data = {
      labels: TopStateData.map((item) => item.States),

      datasets: [
        {
          label: 'Top 10 State Data',
          backgroundColor: ['#316bfe',
            '#ff8100',
            '#02b7f9',
            '#ff9028',
            '#fd4a22',
            '#9f76ff'],
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: TopStateData.map((item) => item.Users)
        }
      ]
    };
    const options = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            fontColor: textColor
          }
        },
        datalabels: {
          formatter: (value, context) => {
            // Access the custom label from labelData array
            return `${TopStateData[context.dataIndex]?.Percents}%` || 'N/A';
          },
          color: 'Black',
          anchor: 'auto',
          align: 'Center',
        },


        customClickPlugin: {
          id: 'customClickPlugin',
          afterEvent: (chart, args) => {
            const event = args.event;

            // Check if it's a click event
            if (event.type === 'click') {
              const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

              if (elements.length) {
                const { index } = elements[0];

                const labelName = data.labels[index];
                handleUserDataNavigate(`getTop10UserDashboardData/${labelName}`, `Total Users From ${labelName}`)
              }
            }
          }
        }






      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500
            }
          },
          grid: {
            display: false,
            drawBorder: false
          }
        },
        y: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        }
      }
    };

    setTopStatechartData(data)
    setTopStatechartOptions(options);
  }


  function HandleTopCity() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const data = {
      labels: TopCitiesData.map((item) => item.City),
      datasets: [
        {
          label: 'Top 10 City Data',
          backgroundColor: ['#316bfe',
            '#ff8100',
            '#02b7f9',
            '#ff9028',
            '#fd4a22',
            '#9f76ff'],
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: TopCitiesData.map((item) => item.Users)
        }
      ]
    };
    const options = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            fontColor: textColor
          }
        },
        datalabels: {
          formatter: (value, context) => {
            // Access the custom label from labelData array
            return `${TopCitiesData[context.dataIndex]?.Percents}%` || 'N/A';
          },
          color: 'Black',
          anchor: 'auto',
          align: 'Center',
        },


        customClickPlugin: {
          id: 'customClickPlugin',
          afterEvent: (chart, args) => {
            const event = args.event;

            // Check if it's a click event
            if (event.type === 'click') {
              const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

              if (elements.length) {
                const { index } = elements[0];

                const labelName = data.labels[index];
                handleUserDataNavigate(`getTop10UserDashboardData/${labelName}`, `Total Users From ${labelName}`)
              }
            }
          }
        }






      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500
            }
          },
          grid: {
            display: false,
            drawBorder: false
          }
        },
        y: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        }
      }
    };

    setCityUsersData(data)
    setCityUsersDataOption(options);
  }



  function HandleGender() {

    const documentStyle = getComputedStyle(document.documentElement);

    const data = {
      labels: [`Males ${totalcount.TotalMales}`,
        `Females ${totalcount.TotalFemales}`,
        `Others ${totalcount.PreferNotToSay}`],
      datasets: [
        {
          data: [
            `${totalcount.TotalMales}`,
            `${totalcount.TotalFemales}`,
            `${totalcount.PreferNotToSay}`,
          ],
          backgroundColor: [
            '#b057da',
            '#FFCE56',
            '#199513'
          ],
          hoverBackgroundColor: [
            '#36A2EB',
            '#FFCE56',
            '#4BC0C0'
          ]
        }
      ]

    };



    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: 'bottom' // Positions legend at the bottom
        },
        customClickPlugin: {
          id: 'customClickPlugin',
          afterEvent: (chart, args) => {
            const event = args.event;

            // Check if it's a click event
            if (event.type === 'click') {
              const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

              if (elements.length) {
                const { index } = elements[0];
                const labelName = data.labels[index];
                let Heading = data.labels[index];
                // console.log(labelName);
                let url = ''
                if (labelName === `Males ${totalcount.TotalMales}`) {
                  Heading = "Total Males Users"
                  url = 'TotalMales'
                }
                else if (labelName === `Females ${totalcount.TotalFemales}`) {
                  Heading = "Total Females Users"
                  url = 'TotalFemales'
                }
                else if (labelName === `Others ${totalcount.PreferNotToSay}`) {
                  Heading = "Total Others Users"
                  url = 'PreferNotToSay'
                }

                handleUserDataNavigate(`getUserDashboardData/${url}`, Heading);
              }
            }
          }
        }
      }



    };

    setGenderUsersData(data);
    setGenderUsersDataOption(options);


  }


  function handlePaidUnpaidUser() {
    const documentStyle = getComputedStyle(document.documentElement);
    const data = {
      labels: [`Paid User ${totalcount.PaidUsers}`, `Unpaid User ${totalcount.FreeUsers}`, `Old User ${totalcount.OldUsers}`,`Coordinators ${totalcount.TotalCoordinators}`],
      datasets: [
        {
          data: [
            `${totalcount.PaidUsers}`,
            `${totalcount.FreeUsers}`,
            `${totalcount.OldUsers}`,
            `${totalcount.TotalCoordinators}`,
          ],
          backgroundColor: [
            '#b057da',
            '#FFCE56',
            '#199513',
            '#316bfe'
          ],
          hoverBackgroundColor: [
            '#b057da',
            '#FFCE56',
            '#199513',
            '#316bfe'
          ]
        }
      ]
    };

    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: 'bottom' // Positions legend at the bottom
        },
        customClickPlugin: {
          id: 'customClickPlugin',
          afterEvent: (chart, args) => {
            const event = args.event;

            // Check if it's a click event
            if (event.type === 'click') {
              const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

              if (elements.length) {
                const { index } = elements[0];
                let labelName = data.labels[index];
                let HeadingName = data.labels[index]
                if (labelName === `Paid User ${totalcount.PaidUsers}`) {
                  labelName = "PaidUsers";
                }
                if (labelName === `Unpaid User ${totalcount.FreeUsers}`) {
                  labelName = "FreeUsers";
                }
                if (labelName === `Old User ${totalcount.OldUsers}`) {
                  labelName = "OldUsers";
                }
                if (labelName === `Coordinators ${totalcount.TotalCoordinators}`) {
                  labelName = "TotalCoordinators";
                }
                // console.log(labelName);

                handleUserDataNavigate(`getUserDashboardData/${labelName}`, `Total ${HeadingName}`);
              }
            }
          }
        }
      }
    };
    setPaidUsersData(data);
    setPaidUsersDataOption(options);
  }

  function handleActiveInactiveUser() {
    const documentStyle = getComputedStyle(document.documentElement);
    const data = {
      labels: [`Active User ${totalcount.LoggedinUsers}`, `Inactive User ${totalcount.LogoutUsers}`],
      datasets: [
        {
          data: [
            `${totalcount.LoggedinUsers}`,
            `${totalcount.LogoutUsers}`,
          ],
          backgroundColor: [
            '#b057da',
            '#FFCE56',
          ],
          hoverBackgroundColor: [
            '#b057da',
            '#FFCE56',
          ]
        }
      ]
    };

    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: 'bottom' // Positions legend at the bottom
        },
        customClickPlugin: {
          id: 'customClickPlugin',
          afterEvent: (chart, args) => {
            const event = args.event;

            // Check if it's a click event
            if (event.type === 'click') {
              const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

              if (elements.length) {
                const { index } = elements[0];
                let labelName = data.labels[index];
                let HeadingName = data.labels[index]
                if (labelName === `Active User ${totalcount.LoggedinUsers}`) {
                  labelName = "LoggedinUsers";
                }
                if (labelName === `Inactive User ${totalcount.LogoutUsers}`) {
                  labelName = "LogoutUsers";
                }
                // console.log(labelName);

                handleUserDataNavigate(`getUserDashboardData/${labelName}`, `Total ${HeadingName}`);
              }
            }
          }
        }
      }
    };
    setActiveInactiveUserData(data);
    setActiveInactiveUserDataOption(options);
  }




  function HandleUserMonthWise() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    let data;



    if (!userLists || userLists.length === 0) {
      data = {
        labels: [],
        datasets: [
          {
            label: 'Total Users',
            backgroundColor: ['#316bfe',
              '#ff8100',
              '#02b7f9',
              '#ff9028',
              '#fd4a22',
              '#9f76ff'],
            borderColor: documentStyle.getPropertyValue('--blue-500'),
            data: []
          }
        ]
      };
    }

    else {
      data = {
        labels: userLists.map((item) => item.months),
        datasets: [
          {
            label: 'Total Users',
            backgroundColor: ['#316bfe',
              '#ff8100',
              '#02b7f9',
              '#ff9028',
              '#fd4a22',
              '#9f76ff'],
            borderColor: documentStyle.getPropertyValue('--blue-500'),
            data: userLists.map((item) => item.total_users)
          }
        ]
      };

    }







    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            fontColor: textColor
          }
        },



        customClickPlugin: {
          id: 'customClickPlugin',
          afterEvent: (chart, args) => {
            const event = args.event;

            // Check if it's a click event
            if (event.type === 'click') {
              const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

              if (elements.length) {
                const { index } = elements[0];

                const labelName = data.labels[index];
                handleUserDataNavigate(`getTotalUserDashboardData/${TotalUserChoosenYears}/${labelName}`, `Total User in ${labelName} ${TotalUserChoosenYears}`)
              }
            }
          }
        }






      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500
            }
          },
          grid: {
            display: false,
            drawBorder: false
          }
        },
        y: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        }
      }
    };

    setTotalUserData(data);
    setTotalUserDataOption(options);
  }


  const handleUserDataNavigate = (value, heading) => {
 
    navigate("/admin/userlist/data", {
      state: { value, heading },
    });
    
  }


  // const fetchTotalCorrdinator = async() => {
  //   let loginuser = JSON.parse(localStorage.getItem("userdetails"));
  //   const token = localStorage.getItem('token');    
  //   const response = await fetch(`${BASE_URL}/getUserDashboardData/TotalCoordinators`, {
  //     method: "GET",
  //     headers: {
  //       'Authorization': `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   }).then((res) => res.json())
  //   .then((res) => {
  //     console.log("res", res);
  //     if (res.status === 200) {
  //       setTotalCoordinator(res.usersData);
  //       console.log("UserData ", res.usersData);

  //       // setfilteredUserLists(res.usersData);
  //       console.log(res.usersData);

  //       let loginuser = JSON.parse(localStorage.getItem("userdetails"));
  //       setLoginuser(loginuser);
  //       setLoading(false);
  //     } else {

  //       if (res.status === 400) {
  //         setTotalCoordinator([]);
  //         // setfilteredUserLists({});
  //       } else if (res.status === 403) {
  //         setSessionExpired(true)
  //         setTimeout(() => {
  //           setSessionExpired(false)
  //           navigate('/login')
  //         }, 5000)
  //       }
  //       else if (res.status === 401) {
  //         setSessionExpired(true)
  //         setTimeout(() => {
  //           setSessionExpired(false)
  //           navigate('/login')
  //         }, 5000)
  //       } else {


  //         setApiError(true);
  //         setMessageDialog(true);
  //         setTimeout(() => {
  //           setMessageDialog(false);
  //           setApiError(false);

  //         }, 1700);
  //       }
  //     }

  //   }).catch((error) => {
  //     setApiError(true);
  //     setMessageDialog(true);
  //     setTimeout(() => {
  //       setMessageDialog(false);
  //       setApiError(false);

  //     }, 1700);

  //   })
  // }


  const handleChangeCurrentYear = (e) => {
    setTotalUserChoosenYears(e.target.value);
    fetchuserdata(e.target.value);
    console.log(e.target.value);
  }

  if (loading) {
  return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
  );
}

  return (
  <div className="user-list-page pt-0 md:pt-0 ">
  
        <div className="add-user user-list">
          <div className="userlist_Heading">User Dashboard</div>

            {/* Pie Chart  */}

            <div className="UserChart_Container">

              <div className="Chart_Data">
                <h2>Total Users</h2>
                <Chart type="doughnut" data={TotalUser} options={chartOptions} onClick={() => { handleUserDataNavigate("getUserDashboardData/TotalUsers", "Total Users") }} />
              </div>

              <div className="Chart_Data">
                <h2>Active & Inactive </h2>
                <Chart type="doughnut" data={ActiveInactiveUserData} options={activeInactiveUserDataOption} plugins={[activeInactiveUserDataOption.plugins.customClickPlugin]} />
              </div>

              <div className="Chart_Data">
                <h2>Active Subscriber</h2>
                <Chart type="doughnut" data={ActiveSubscriptions} options={chartOptions} onClick={() => { handleUserDataNavigate("getUserDashboardData/ActiveSubscriptions", "Total Active Subscriber") }} />
              </div>

              {/* <div className="Chart_Data">
                <h2>Inactive Users</h2>
                <Chart type="doughnut" data={InactiveUsersData} options={chartOptions} onClick={() => { handleUserDataNavigate("getUserDashboardData/LogoutUsers", "Total Inactive Users") }} />
              </div> */}



            </div>


            
            

            <div className="UserChart_Container">

              <div className="Chart_Data">
                <h2>Blocked Users</h2>
                <Chart type="doughnut" data={BlockedUsersData} options={chartOptions} onClick={() => { handleUserDataNavigate("getUserDashboardData/BlockedUsers", "Total Blocked Users") }} />
              </div>

              <div className="Chart_Data">
                <h2>Paid, Unpaid and Coordinators </h2>
                <Chart type="doughnut" data={PaidUsersData} options={PaidUsersDataOption} plugins={[PaidUsersDataOption.plugins.customClickPlugin]} />
              </div>

              <div className="Chart_Data">
                <h2>Gender</h2>
                <Chart type="doughnut" data={GenderUsersData} options={GenderUsersDataOption} plugins={[GenderUsersDataOption.plugins.customClickPlugin]} />
              </div>

            </div>

            <div className="UserChart_Container">
              <div className="UserChart_card">
                <h2>Age Wise User</h2>
                <Chart type="bar" data={AgeWisechartData} options={AgeWisechartOptions} plugins={[AgeWisechartOptions.plugins.customClickPlugin]} />
              </div>

              <div className="UserChart_card">
                <h2>Top 10 States</h2>
                <Chart type="bar" data={TopStatechartData} options={TopStatechartOptions} plugins={[TopStatechartOptions.plugins.customClickPlugin, ChartDataLabels]} />
              </div>
            </div>

            <div className="UserChart_Container">

              <div className="UserChart_card">
                <h2>Top 10 Cities</h2>
                <Chart type="bar" data={CityUsersData} options={CityUsersDataOption} plugins={[CityUsersDataOption.plugins.customClickPlugin, ChartDataLabels]} />
              </div>

              <div className="UserChart_card">
                <div style={{display: 'flex', justifyContent: 'space-between'}}>

                <h2>Total Users</h2>

                  <select
                    value={TotalUserChoosenYears}
                    name="totalUserYears"
                    className="TotalUser_YearSelect_group"
                    onChange={handleChangeCurrentYear}
                  >
                    {TotalUserYears.map((items, index) => (
                      <option value={items.Years} key={index}>
                        {items.Years}
                      </option>
                    ))}
                  </select>

                 
                </div>

                {userLists.length === 0 || !userLists ?
                  <div>No data found</div>
                  :
                  <Chart type="bar" data={TotalUserData} options={TotalUserDataOption} plugins={[TotalUserDataOption.plugins.customClickPlugin]} />
                }
              </div>

            </div>



            <TelegramWidget />

            {/* Age wise data chart   */}

            <Dialog
              open={messageDialog}
              onClose={() => { setMessageDialog(false) }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">

                {isSuccess ? <h4 style={{ color: "green" }}>Success</h4> : null}
                {isFailed ? <h4 style={{ color: "red" }}>Failure</h4> : null}
                {/* {ApiError ?<h4 style={{ color: "red" }}>Failure</h4>:null} */}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">


                  {isSuccess ?
                    <span style={{ color: "black" }}>
                      User Successfully Deleted.
                    </span>
                    : null}
                  {isFailed ?
                    <span style={{ color: "black" }}>
                      Failed To Delete User.
                    </span> : null}

                  {ApiError ?
                    <span style={{ color: "black" }}>
                      We're sorry, but something went wrong while processing your request.
                    </span> : null}

                </DialogContentText>
              </DialogContent>

            </Dialog>
          </div>
        
      
     
      {sessionExpired ? <SessionLogout /> : null}
    </div>
  );
};

export default Userlist;
